import { QuestionGroup, ScenarioStep, Steps } from '../state/interfaces'
import { confirm, thanks, emailAddress } from './common-steps'

export const emailAddressNewsletter: ScenarioStep = {
  ...emailAddress,
  group: QuestionGroup.NEWSLETTER,
  question: 'email-address-newsletter_question',
  tip: 'email-address-newsletter_tip',
  answerPlaceholder: 'email-address-newsletter_answerPlaceholder',
  next: Steps.CONFIRM_NEWSLETTER,
}

export const confirmNewsletter: ScenarioStep = {
  ...confirm,
  id: Steps.CONFIRM_NEWSLETTER,
  group: QuestionGroup.NEWSLETTER,
  question: 'confirm-newsletter_question',
  answerPlaceholder: 'confirm-newsletter_answerPlaceholder',
  next: Steps.THANKS,
}

export const thanksNewsletter: ScenarioStep = {
  ...thanks,
  group: QuestionGroup.NEWSLETTER,
  question: 'thanks-newsletter_question',
  tip: 'thanks-newsletter_tip',
}
